/* ui/game/configuration/FPS.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	to_number
} from "svelte/internal";

import { APP } from "../../store";

function add_css() {
	var style = element("style");
	style.id = "svelte-110vxdj-style";
	style.textContent = ".container.svelte-110vxdj{display:grid;grid-template-columns:1fr 1fr}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div1;
	let label;
	let t1;
	let div0;
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			div1 = element("div");
			label = element("label");
			label.textContent = "Game Speed:";
			t1 = space();
			div0 = element("div");
			input = element("input");
			attr(input, "type", "range");
			attr(input, "min", "10");
			attr(input, "step", "0.5");
			attr(input, "max", "60");
			attr(div1, "class", "container svelte-110vxdj");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, label);
			append(div1, t1);
			append(div1, div0);
			append(div0, input);
			set_input_value(input, /*fps*/ ctx[0]);

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_input_handler*/ ctx[1]),
					listen(input, "input", /*input_change_input_handler*/ ctx[1])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*fps*/ 1) {
				set_input_value(input, /*fps*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let fps = 1;
	APP.ticker.minFPS = 10;

	function input_change_input_handler() {
		fps = to_number(this.value);
		$$invalidate(0, fps);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*fps*/ 1) {
			// transform the fps so there's more slow options
			$: APP.ticker.maxFPS = fps * fps / 60;
		}
	};

	return [fps, input_change_input_handler];
}

class FPS extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-110vxdj-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default FPS;